import FilterChipMixin from './mixin.js';

export const YAW__VertexNameFilterChip = {
  mixins: [FilterChipMixin],

  computed: {
    text_value: function() {
      var filters;

      filters = _.chain(this.filter.value)
        .map((_filter) => {
          if (_filter.field === this.filter.field) {
            return _filter.value;
          } else {
            if (_filter.value) {
              return _filter.value.value;
            }
          }
        })
        .compact()
        .value();
      return filters.join(', ');
    }
  }
};

export const YAW__JourneyStatusFilterChip = {
  mixins: [FilterChipMixin],

  computed: {
    text_value: function() {
      var filters;

      filters = _.map(this.filter.value, (_filter) => {
        if (_filter.field === this.filter.field) {
          return (_.map(_filter.value, (v) => Skylark.Helpers.translate(`journey.status.${v}`))).join(',');
        } else {
          if (_filter.value) {
            return _filter.value.value;
          }
        }
      });
      return filters.join(', ');
    }
  }
};
